import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { DialogHelper } from "../core/util/dialogHelper";
import { Config } from "../core/config/config";
import { SheetEventType } from "../../siteManagement/sheet";
import { Helper } from "../core/util/helper";
import { EntityAddress } from "../address/address";
import { PageTitleProps } from "../core/components/pageTitle";
import React from "react";
export default class ContactApp extends React.Component<ContactAppProps, any> {
    common = new AppHelper();
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    deleteEnabled = false;
    isDeleted = false;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);

        this.refreshDeleteEnabled();
        this.handleFieldChange({ model: "entity.Inaktiv" }, this.props.entity.Inaktiv, null, true);
        this.handleFieldChange({ model: "entity.Master" }, this.props.entity.Master, null, true);
    }


    private refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    save = async (closeAfterSave) => {
        for (const loadedModule of this.common.getLoadedModules()) {
            loadedModule.Save();
        }
        if (this.common.validate()) {
            const result = await HTTPService.post<JsonResultClass>("Contact/Save", this.props.entity)
            if (result.Code === 0) {
                if (this.props.entity.IsNew /*&& !this.common.isWindow*/) {
                    const data = this.common.sheetWrapper.getExternalData();
                    if (!data || data.preventUrlChangeOnNew !== true) {
                        General.Functions.HistoryState.replaceState("Contact/Edit?id=" + this.props.entity.Pos);
                    }
                }
                this.props.entity.IsNew = false;
                this.refreshDeleteEnabled();
                NotificationHelper.showSuccessMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0, closeAfterSave);
        }

    }

    remove = () => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOK => {
            if (isOK) {
                HTTPService.post<JsonResultClass>('Contact/Delete?pos=' + encodeURIComponent(this.props.entity.Pos.toString()) + '&adrnr=' + encodeURIComponent(this.props.entity.AdrNr))
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            if (this.common.isWindow) {
                                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                                this.common.sheetWrapper.hide();
                            } else {
                                this.deleteEnabled = false;
                                this.isDeleted = true;
                                this.props.entity.RecordRight.CanWrite = false;
                                this.setState({});
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/Contact";
                                }, 1000);
                            }
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    private setBusinessAddressFallBackData = async (adrNr: string) => {
        const result = await HTTPService.get<JsonResultClass<EntityAddress>>(`Address/Init/?id=${adrNr}`)
        if (result.Code == 0) {
            const address = result.Data;
            //Email
            if (Helper.isNullOrEmpty(this.props.entity["Email1"])) {
                this.handleFieldChange({ model: "entity.Email1" }, address["Email"]);
            }
            //Telefon
            if (Helper.isNullOrEmpty(this.props.entity["Telefon1"])) {
                this.handleFieldChange({ model: "entity.Telefon1" }, address["Telefon"]);
            }
            //Fax
            if (Helper.isNullOrEmpty(this.props.entity["Fax"])) {
                this.handleFieldChange({ model: "entity.Fax" }, address["Fax"]);
            }

        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
    }

    private setPrivatAddressFallBackData = async (adrNr: string) => {
        const result = await HTTPService.get<JsonResultClass<EntityAddress>>(`Address/Init/?id=${adrNr}`)
        if (result.Code == 0) {
            const address = result.Data;
            //Email
            if (Helper.isNullOrEmpty(this.props.entity["Email2"])) {
                this.handleFieldChange({ model: "entity.Email2" }, address["Email"]);
            }
            //Telefon
            if (Helper.isNullOrEmpty(this.props.entity["Telefon2"])) {
                this.handleFieldChange({ model: "entity.Telefon2" }, address["Telefon"]);
            }

        } else {
            NotificationHelper.showErrorMessage(result.Message)
        }
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Master":
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.Inaktiv", value);
                break;
            case "entity.Inaktiv":
                MetaDataHelper.setReadOnly(this.props.metadata, "entity.Master", value);
                break;
            case "entity.AdrNr":
                this.setBusinessAddressFallBackData(value)
                break;
            case "entity.Adrnr2":
                this.setPrivatAddressFallBackData(value)
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    openCockpit = () => {
        General.Sheet.Manager.createSheetWithUrl(`Cockpit/IndexContact?id=${encodeURIComponent(this.props.entity.Pos)}-${encodeURIComponent(this.props.entity.AdrNr)}`, null, null, false);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.Ansprechpartner
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};

export interface ContactAppProps extends AppBaseProps {
    entity: EntityContact;
}

export interface EntityContact extends Entity {
    Inaktiv: boolean;
    Master: boolean;
    Pos: number;
    Ansprechpartner: string;
    AdrNr: string;
    Email1?: string;
}